import { getInterfaceBackgroundColor, getPrimaryColorTokens, getSidebarColorTokens } from './core/_utils';

export const getInterfaceColorTokens = (
  primaryColor?: string,
  sidebarColor?: string,
  backgroundColor?: string,
): Record<string, string> => {
  const primaryTokens = getPrimaryColorTokens(primaryColor);
  const sidebarTokens = getSidebarColorTokens(sidebarColor, primaryColor);
  const background = getInterfaceBackgroundColor(backgroundColor);
  return { ...primaryTokens, ...sidebarTokens, '--app-interface-background': background };
};
